import * as yup from "yup";
import { ReRunDayBreaksFormValues } from "./ReRunDayBreaksModal.types";

export const reRunDayBreaksSchema = yup.object().shape({
  schedule_start_date: yup
    .string()
    .required("Please select a start date.")
    .trim()
    .test("non-empty", "Please select a start date.", (value) => Boolean(value?.trim())),
  timeMode: yup.string().oneOf(["hours", "days"]).required() as yup.StringSchema<
    ReRunDayBreaksFormValues["timeMode"]
  >,
  hours: yup
    .number()
    .min(1, "Hours should be a positive number.")
    .max(24)
    .when("timeMode", {
      is: "hours",
      then: (schema) => schema.required("Hours should be a positive number."),
      otherwise: (schema) => schema.optional(),
    }),
  maxDays: yup
    .number()
    .min(5, '"Max total days" should be greater than or equal to 5')
    .max(366)
    .when("timeMode", {
      is: "days",
      then: (schema) =>
        schema
          .required("Days should be a positive number.")
          .min(5, '"Max total days" should be greater than or equal to 5'),
      otherwise: (schema) => schema.optional(),
    }),
  working_days: yup
    .array()
    .of(yup.number().min(1).max(7))
    .min(1, "Select at least one working day.")
    .max(7)
    .default([]),
  exclude_national_holidays: yup.boolean().default(true),
}) as yup.ObjectSchema<ReRunDayBreaksFormValues>;
